import * as React from 'react';

import { HomePageView } from './home-page.view';
import { useFeatureHomePage } from './use-feature-home-page';

const HomePage = () => {
  const { featureHomePageLoading, featureHomePage } = useFeatureHomePage();

  return <HomePageView isLoading={featureHomePageLoading} featureHomePage={featureHomePage} />;
};

export default HomePage;
